//保存些零碎的状态
const state = {
  brandList: { activeCate: "0", activeCateId: 0, activeStatus: "预告" },
};
const mutations = {
  CHANGE_BRANDLIST_STATE(state, data) {
    state.brandList = data;
  },
};
const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
